/**
 * Export `apiEndpoints`.
 */

export const apiEndpoints = {
  aiMissingDrug: '/admin/ai/missing-drug',
  login: '/auth',
  orders: '/admin/orders',
  retryOrder: '/admin/orders/${id}/retry',
  sales: '/admin/sales',
  salesById: '/admin/sales/${id}',
  ccis: '/admin/ccis',
  ccisById: '/admin/ccis/${id}',
  ccisCodes: '/admin/ccis-codes',
  ccisCodesById: '/admin/ccis-codes/${cci}',
  ccisDrugs: '/admin/ccis-drugs',
  ccisDrugsById: '/admin/ccis-drugs/${cci}/${drugId}',
  userInfo: '/auth/me',
  experimentalFeatures: '/admin/experimental-features',
  experimentalFeaturesById: '/admin/experimental-features/${id}',
  userChangeExperimentalFeature: '/admin/users/${userId}/experimental-features',
  users: '/admin/users',
  usersByPhone: '/admin/users/by-phone',
  usersById: '/admin/users/${userId}',
  usersDelete: '/admin/users/${userId}',
  usersEdit: '/admin/users/${userId}',
  dialCodes: '/admin/dial-codes',
  dialCodesById: '/admin/dial-codes/${id}',
  flags: '/common/flag/${code}',
  biometricData: '/admin/users/${userId}/biometric-data',
  metricsUsers: '/admin/metrics/users',
  userSettings: '/admin/users/${userId}/settings',
  userSettingsById: '/admin/users/${userId}/settings/${settingId}',
  userAuthorizations: '/admin/users/${userId}/authorizations',
  userDefinedAlarms: '/admin/users/${userId}/defined-alarms',
  userDefinedAlarmsById: '/admin/users/${userId}/defined-alarms/${id}',
  userAuthorizationsById: '/admin/users/${userId}/authorizations/${id}',
  userSales: '/admin/users/${userId}/sales',
  userSalesEdit: '/admin/users/${userId}/sales/${id}',
  userSaleItemFormCode: '/admin/users/${userId}/sales/form-code/${saleId}',
  userSaleItemToTherapy: '/admin/users/${userId}/sale-item/to-therapy',
  userSalesById: '/admin/users/${userId}/sales/${id}',
  userPushTokens: '/admin/users/${userId}/push-tokens',
  userDevTherapySyncLogs: '/admin/users/${userId}/dev/therapy-sync-logs',
  userDevTherapySyncLogsById: '/admin/users/${userId}/dev/therapy-sync-logs/${id}',
  userPushTokensById: '/admin/users/${userId}/push-tokens/${id}',
  userDevices: '/admin/users/${userId}/devices',
  userDevicesById: '/admin/users/${userId}/devices/${id}',
  integrationsConsentPhoneNumber: '/integrations/register',
  integrationsConsentPhoneNumberConfirm: '/integrations/register/confirm',
  userMedications: '/admin/users/${userId}/medications',
  userMedicationsById: '/admin/users/${userId}/medications/${id}',
  userPinNumbers: '/admin/users/${userId}/pin-numbers',
  userChangePassword: '/admin/users/${userId}/change-password',
  userPinNumbersById: '/admin/users/${userId}/pin-numbers/${id}',
  supportOpenTickets: '/admin/support',
  supportOpenTicketsById: '/admin/support/${id}',
  supportReplyTicket: '/admin/support/${id}/messages',
  supportTicketStatus: '/admin/support/${id}/status/${status}',
  languages: '/admin/languages',
  userCustomNotification: '/admin/users/${userId}/send-notification',
  languagesById: '/admin/languages/${code}',
  devices: '/admin/devices',
  devicesById: '/admin/devices/${id}',
  pharmaciesAuthorizations: '/admin/pharmacies/${pharmacyId}/authorizations',
  pharmaciesConsents: '/admin/pharmacies/${pharmacyId}/consents',
  pharmaciesConsentsByPhoneNumber: '/admin/pharmacies/${pharmacyId}/consents/${phoneNumber}',
  drugs: '/admin/drugs',
  subscriptions: '/admin/subscriptions',
  subscriptionsById: '/admin/subscriptions/${id}',
  subscriptionsUsers: '/admin/subscriptions/${subscriptionId}/users',
  subscriptionsUsersById: '/admin/subscriptions/${subscriptionId}/users/${pharmacyId}/${userId}',
  drugsById: '/admin/drugs/${id}',
  missingDrugs: '/admin/missing-drugs',
  missingDrugsById: '/admin/missing-drugs/${id}',
  missingDrugsOccurrences: '/admin/missing-drugs/${code}/occurrences',
  missingDrugsDelete: '/admin/missing-drugs/${id}',
  drugsDelete: '/admin/drugs/${id}',
  translate: '/admin/translate',
  logout: '/auth/logout',
  posologyEnumDuration: '/admin/posology/enums/duration',
  posologyEnumFrequency: '/admin/posology/enums/frequency',
  posologyEnumQuantity: '/admin/posology/enums/quantity',
  countries: '/admin/countries',
  pharmacies: '/admin/pharmacies',
  pharmaciesById: '/admin/pharmacies/${id}',
  pharmaciesUserStats: '/admin/pharmacy-users',
  pharmaciesIntegrations: '/admin/pharmacies/${pharmacyId}/integrations',
  pharmaciesIntegrationsById: '/admin/pharmacies/${pharmacyId}/integrations/${id}',
  logs: '/admin/logs-api',
  logsById: '/admin/logs/${id}',
  logsVersions: '/admin/logs-api/versions',
  logsTypes: '/admin/logs-api/types',
  logsModules: '/admin/logs-api/modules',
  logsDelete: '/admin/logs-api/delete',
  logsTherapy: '/admin/logs-therapy',
  logsTherapyById: '/admin/logs-therapy/${id}',
  logsTherapyDelete: '/admin/logs-therapy/delete',
  ignoreUrlLogs: '/admin/ignore-url-logs',
  ignoreUrlLogsById: '/admin/ignore-url-logs/${id}',
  translations: '/admin/translations',
  translationsById: '/admin/translations/${id}',
  translationsVersions: '/admin/translations/versions',
  missingTranslations: '/admin/missing-translations',
  missingTranslationsById: '/admin/missing-translations/${id}',
  dataExports: '/admin/data-exports',
  dataExportsById: '/admin/data-exports/${id}',
  dataExportsDownload: '/admin/data-exports/${id}/download',
  dataExportsDelete: '/admin/data-exports/${id}',
  dataExportsMarkViewed: '/admin/data-exports/mark-viewed',
  dataExportsUnseenCount: '/admin/data-exports/unseen-count',
  dataExportsClearAll: '/admin/data-exports/clear-all',
  resourceExport: '/admin/${resource}/export',
  config: '/admin/config',
  configById: '/admin/config/${id}',
  developerUsers: '/admin/sms-test/users',
  smsTest: '/admin/sms-test',
  pharmacyPlan: {
    planTypes: '/admin/pharmacy-plan-types',
    planTypesById: '/admin/pharmacy-plan-types/${id}',
    plans: '/admin/pharmacy-plans/${pharmacyId}',
    ledger: '/admin/pharmacy-plans/${pharmacyId}/ledger',
    credit: '/admin/pharmacy-plans/${pharmacyId}/credit',
    debit: '/admin/pharmacy-plans/${pharmacyId}/debit',
    campaigns: '/admin/pharmacy-campaigns',
    campaignsById: '/admin/pharmacy-campaigns/${id}'
  }
} as const;
